// extracted by mini-css-extract-plugin
export default {"display_left":"style_display_left__xiWKO","display_right":"style_display_right__SRYGa","table_wrap":"style_table_wrap__Yy4Kr","popup":"style_popup__3L+Y3"};